import { apiGet, apiPut, apiPost, apiDelete } from "./client";

export interface AiProviderConfig {
  providerId: string;
  name: string;
  enabled: boolean;
  apiKey?: string;
  baseUrl?: string;
  defaultModel: string;
  models?: string[];
  createdAt: string;
  updatedAt: string;
}

export async function listAiProviders(): Promise<AiProviderConfig[]> {
  const res = await apiGet<{ providers: AiProviderConfig[] }>("/api/ai-providers");
  return res.providers ?? [];
}

export async function getAiProvider(id: string): Promise<AiProviderConfig> {
  return apiGet<AiProviderConfig>(`/api/ai-providers/${id}`);
}

export async function updateAiProvider(id: string, updates: Partial<AiProviderConfig>): Promise<AiProviderConfig> {
  const res = await apiPut<{ provider: AiProviderConfig }>(`/api/ai-providers/${id}`, updates);
  return res.provider;
}

export async function testAiProvider(id: string, config?: { apiKey?: string; baseUrl?: string; model?: string }): Promise<{ success: boolean; response: string }> {
  return apiPost<{ success: boolean; response: string }>(`/api/ai-providers/${id}/test`, config ?? {});
}

export async function deleteAiProvider(id: string): Promise<void> {
  await apiDelete(`/api/ai-providers/${id}`);
}